import React from 'react';

export default function NotEligibleScreen() {
  return (
    <div className="bg-gradient-to-br from-gray-100 to-blue-100 border-4 border-black p-10 rounded-3xl shadow-[16px_16px_0px_0px_rgba(0,0,0,1)] text-center max-w-3xl mx-auto mt-2">
      <div className="mb-8">
        <h1 className="text-5xl font-extrabold text-gray-800 mb-2 drop-shadow-lg">Not Eligible</h1>
        <p className="text-xl text-gray-700 mb-4 font-medium">Unfortunately, you do not meet the eligibility criteria to mint this NFT.</p>
      </div>
      <div className="bg-blue-100 border-4 border-black w-64 h-64 mx-auto mb-8 flex items-center justify-center rounded-2xl shadow-[10px_10px_0px_0px_rgba(0,0,0,1)]">
        <span className="text-8xl" role="img" aria-label="sad croissant">🥐</span>
      </div>
      <div className="bg-white/80 border-2 border-dashed border-blue-400 p-4 mb-8 rounded-xl shadow-sm">
        <p className="text-lg text-gray-800 font-semibold flex items-center justify-center gap-2">
          <span role="img" aria-label="info">ℹ️</span>
          You need more than 1000 followers on Twitter to be eligible.
        </p>
      </div>
      <p className="text-gray-600 mt-6">If you believe this is a mistake, please try again or contact support.</p>
    </div>
  );
} 